import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import {
  getPublicRecordingHlsManifestOptions,
  signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetOptions,
} from '@/api';
import VideoPlayer from '@/components/VideoPlayer';

/** Recording player without a login: /dev/video-preview?room=<roomId>&mp4=1 forces the MP4 fallback. */
export const Route = createFileRoute('/dev/video-preview')({
  validateSearch: (search: Record<string, unknown>) => ({
    room: typeof search.room === 'string' ? search.room : '',
    mp4: search.mp4 === 1 || search.mp4 === '1' || search.mp4 === true,
  }),
  component: VideoPreview,
});

function VideoPreview() {
  const { room, mp4 } = Route.useSearch();
  const path = { path: { room_id: room } };
  const hls = useQuery({ ...getPublicRecordingHlsManifestOptions(path), enabled: !!room && !mp4, retry: false });
  const file = useQuery({
    ...signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetOptions(path),
    enabled: !!room,
    retry: false,
  });
  if (hls.isLoading) return <p className="p-6 text-sm">Loading…</p>;
  const src = file.data?.signed_url;
  return (
    <div className="mx-auto max-w-4xl p-6">
      <p className="mb-2 text-xs text-neutral-500">
        {hls.data ? 'HLS (Shaka)' : src ? 'MP4' : 'No recording'}
      </p>
      <div className="overflow-hidden rounded-3xl bg-black">
        <VideoPlayer
          hlsStream={hls.data}
          options={{ sources: src ? [{ src, type: 'video/mp4' }] : [] }}
        />
      </div>
    </div>
  );
}
